import { melbourneDate } from '../../../shared/dates';
import type { DrivePageRow, DriveRow, ProjectDrive, ProjectDriveInput } from '../../../shared/drives';
import { formatDayMonth } from '../../components/primitives';

export type DrivesSegment = 'active' | 'backup' | 'untagged' | 'all';
export const REGISTER_LINK = '/settings?tab=registers';
export function filterDrives(drives: DrivePageRow[], segment: DrivesSegment): DrivePageRow[] {
  return drives.filter(drive => segment === 'all' || (segment === 'backup' ? drive.backup_count > 0 : drive.status === 'active'));
}
export function freeSpaceText(drive: Pick<DriveRow, 'free_gb' | 'capacity_gb' | 'free_checked_at'>): string {
  if (drive.free_gb === null) return 'Free space not recorded';
  return `${drive.free_gb.toLocaleString('en-AU')} GB free${drive.capacity_gb === null ? '' : ` of ${drive.capacity_gb.toLocaleString('en-AU')} GB`}${drive.free_checked_at === null ? '' : `, checked ${formatDayMonth(melbourneDate(drive.free_checked_at))}`}`;
}

/** Replace only the backup role, retaining the working copy and every other
 * manual archive link. A selected archive gets promoted; an automatic link never
 * enters the PUT. Current links come from a fresh GET immediately before each save. */
export function backupDrivePayload(current: ProjectDrive[], backup: string): ProjectDriveInput[] {
  const manual = current.filter(link => !link.auto_backup);
  if (backup && current.some(link => link.auto_backup && link.drive_id === backup)) throw new Error('Automatic backup drives cannot be assigned manually.');
  if (backup && manual.some(link => link.role === 'primary' && link.drive_id === backup)) throw new Error('That drive holds the working copy. Choose a different backup drive.');
  return [
    ...manual.filter(link => link.role !== 'backup' && !(link.role === 'archive' && link.drive_id === backup)).map(({ drive_id, role }) => ({ drive_id, role })),
    ...(backup ? [{ drive_id: backup, role: 'backup' as const }] : []),
  ];
}
